import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import { Map } from 'immutable';

import { track } from '@xanadu/ui-shared/interfaces/woopra';

import { PRODUCTS } from '../../../constants';

import styles from './PromoBanner.module.scss';

const PromoBanner = ({
  product,
  casinoPromotions,
  exchangePromotions,
  onNavigate,
}) => {
  const isExchange = product === PRODUCTS.exchange;

  const availableExchangePromotions = exchangePromotions
    .filter(({ claimed, eligible }) => eligible && !claimed);

  const firstCasinoPromotion = casinoPromotions.first() || {};
  const firstExchangePromotion = availableExchangePromotions.first() || {};

  const totalPromotions = casinoPromotions.size + availableExchangePromotions.size;

  const promotionsPageUrl = [PRODUCTS.exchange, PRODUCTS.mbzero].includes(product) ? '/promotions/exchange' : '/promotions/casino';

  const showCasinoPromo = (firstCasinoPromotion.id && isExchange) || !firstExchangePromotion.id;

  const {
    eligible,
    claimed,
  } = firstExchangePromotion;

  const promotionLabel = totalPromotions > 1 ? 'promotions' : 'promotion';

  const handleNavigate = (trackingSource) => (url) => {
    onNavigate(url);

    track('Marketing', `Casino Promo Banner - Click on ${trackingSource}`);
  };

  let imageUrl = firstExchangePromotion.id
    ? `/dA/${firstExchangePromotion.imageLink}`
    : '';

  let singlePromotionUrl = firstExchangePromotion.id
    ? `/promotions/exchange/${firstExchangePromotion.id}`
    : '';

  let singlePromotionName = firstExchangePromotion.name;

  if (showCasinoPromo) {
    imageUrl = firstCasinoPromotion.imgUrl;
    singlePromotionUrl = `/promotions/casino/${firstCasinoPromotion.id}`;
    singlePromotionName = firstCasinoPromotion.displayName;
  }

  if (!imageUrl || (!showCasinoPromo && (!eligible || claimed))) {
    return null;
  }

  return (
    <div className={styles.main}>
      <Link
        className={styles.image}
        to={singlePromotionUrl}
        onClick={handleNavigate('banner')}
      >
        <img src={imageUrl} alt="Promotion banner" />
      </Link>
      <div className={styles.text}>
        <span>
          {totalPromotions > 1 ?
            `You have ${totalPromotions} ${promotionLabel} available to you.`
            :
            singlePromotionName
          }
        </span>
        <Link to={promotionsPageUrl} onClick={handleNavigate('view link')}>View</Link>
      </div>
    </div>
  );
};

PromoBanner.propTypes = {
  product: PropTypes.string.isRequired,
  onNavigate: PropTypes.func.isRequired,
  casinoPromotions: PropTypes.instanceOf(Map).isRequired,
  exchangePromotions: PropTypes.instanceOf(Map).isRequired,
};

export default PromoBanner;
